<template>
  <div>
    <v-container>
      <v-row align="center" justify="center">
        <v-col>
          <!-- Card to display the information for bookings -->
          <v-card :loading="loading" class="mx-auto" elevation-24>
            <v-card-title
              class="title font-weight-regular justify-space-between"
            >
              <span>{{ currentTitle }}</span>
              <v-avatar
                color="#962283"
                class="subheading white--text"
                size="48"
                v-text="step"
              ></v-avatar>
            </v-card-title>

            <!-- Set up a step window group to display the steps for wozard to collect data -->
            <v-window v-model="step">
              <!-- Step 1 - ask Association and Date for Booking -->
              <v-window-item :value="1">
                <v-dialog
                  v-model="startPageLoad"
                  hide-overlay
                  persistent
                  width="300"
                >
                  <v-card color="#962283" dark>
                    <v-card-text>
                      Loading Associations - Please stand by
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                      ></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>

                <v-col cols="10"> </v-col>
                <v-form ref="Step 1" lazy-validation class="elevation-24 ma-5">
                  <v-card-text>
                    <v-img
                      :src="require('../assets/logo.png')"
                      class="my-3"
                      contain
                      height="75"
                    />
                    <v-select
                      v-model="selAssociation"
                      :items="associationNames"
                      label="Select your Association"
                      prepend-icon="mdi-home-circle"
                      @change="setAssoc"
                      :rules="[(v) => !!v || 'Association is required']"
                    />

                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormatted"
                          label="Select Date"
                          prepend-icon="mdi-calendar-search"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="seldate"
                        @input="menu2 = false"
                        first-day-of-week="1"
                        color="purple lighten-1"
                      ></v-date-picker>
                    </v-menu>
                    <h4 style="color: red">{{ error }}</h4>
                  </v-card-text>
                </v-form>
              </v-window-item>

              <!-- step 2 - show list of avaliable events and allow user to select an event -->
              <v-window-item :value="2">
                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="events"
                    :items-per-page="10"
                    item-key="Start_Time"
                    class="elevation-24"
                    @click:row="SelectedEvent"
                    v-if="renderEvents"
                  >
                  </v-data-table>
                </v-col>
              </v-window-item>

              <!-- Step 3 - Show a list of People with ability to add or edit and tick for booking -->
              <v-window-item :value="3">
                <v-col cols="12">
                  <v-data-table
                    v-model="selectedPeople"
                    :headers="peopleHeaders"
                    :items="people"
                    :items-per-page="10"
                    item-key="person"
                    class="elevation-24 "
                    show-select
                    :value="selectedPeople"
                    v-if="renderPeople"
                  >
                    <template v-slot:top>
                      <v-toolbar flat color="white">
                        <v-dialog v-model="dialog" max-width="500px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              dark
                              class="mb-2"
                              v-bind="attrs"
                              v-on="on"
                              >Add Person</v-btn
                            >
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                              <v-container>
                                <v-form
                                  ref="Person"
                                  v-model="personValid"
                                  lazy-validation
                                >
                                  <v-row>
                                    <v-col cols="12">
                                      <v-text-field
                                        v-model="editedItem.username"
                                        label="OUG Username (if you have one)"
                                        @blur="LookupUser"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                      <h4 style="color: red">{{ error }}</h4>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        v-model="editedItem.person"
                                        label="Person Name"
                                        :rules="[
                                          (v) => !!v || 'Your Name is required',
                                        ]"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        v-model="editedItem.phone"
                                        label="Mobile Ph #"
                                        :rules="[
                                          (v) => !!v || 'Phone # is required',
                                        ]"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        v-model="editedItem.email"
                                        label="Email Address"
                                        :rules="[
                                          (v) => !!v || 'Email is required',
                                        ]"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                      <v-text-field
                                        v-model="editedItem.address"
                                        label="Address"
                                        :rules="[
                                          (v) => !!v || 'Address is required',
                                        ]"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-form>
                              </v-container>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="close"
                                >Cancel</v-btn
                              >
                              <v-btn color="blue darken-1" text @click="save"
                                >Save Persons Details</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                          <v-dialog
                            v-model="lookup"
                            hide-overlay
                            persistent
                            width="300"
                          >
                            <v-card color="#962283" dark>
                              <v-card-text>
                                Checking OwnUrGoal - Please stand by
                                <v-progress-linear
                                  indeterminate
                                  color="white"
                                  class="mb-0"
                                ></v-progress-linear>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-pencil
                      </v-icon>
                      <v-icon small @click="deleteItem(item)">
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-window-item>

              <!-- step 4 display Bookings -->
              <v-window-item :value="4">
                <v-data-table
                  :headers="bookHeaders"
                  :items="bookings"
                  :items-per-page="10"
                  class="elevation-24"
                  loading-text="Loading Your Bookings ... Please wait"
                >
                </v-data-table>
                <div class="pa-4 text-center">
                  <v-img
                    :src="require('../assets/logo.png')"
                    class="my-3"
                    contain
                    height="75"
                  />
                  <span class="caption grey--text"
                    >Bookings Confirmed! We have sent you an email as
                    confirmation.</span
                  >
                  <p></p>
                  <span class="caption grey--text"
                    >You are ready to attend your event - enjoy!</span
                  >
                </div>
              </v-window-item>
            </v-window>

            <v-divider></v-divider>

            <!-- Action buttons for each step -->
            <v-card-actions>
              <v-btn :disabled="step === 1" text @click="stepAction('-')">
                Back
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="step == 3"
                color="#962283"
                dark
                depressed
                :disabled="selectedPeople.length == 0"
                @click="processBookings"
              >
                Process These Bookings
              </v-btn>
              <v-btn
                v-if="step < 2"
                color="#962283"
                dark
                depressed
                @click="stepAction('+')"
              >
                Next
              </v-btn>
              <v-btn
                v-if="step == 4"
                color="#962283"
                dark
                depressed
                @click="stepAction('+')"
              >
                Finished
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
//import moment from "moment";
import db from "../Database/Database";

export default {
  data() {
    return {
      startPageLoad: false,
      renderEvents: false,
      renderPeople: false,
      dialog: false,
      personValid: true,
      lookup: false,
      loading: false,
      selEvent: "",
      selEventId: 0,
      step: 1,
      menu2: false,
      organisation: 292,
      selAssociation: null,
      associations: [],
      associationNames: [],
      error: "",
      seldate: "",
      headers: [
        {
          text: "Start",
          align: "start",
          sortable: true,
          value: "start_time",
        },
        { text: "End", value: "end_time" },
        { text: "Event", value: "title" },
      ],
      events: [],
      peopleHeaders: [
        {
          text: "Username",
          align: "start",
          sortable: false,
          value: "username",
        },
        {
          text: "Person",
          align: "start",
          sortable: false,
          value: "person",
        },
        { text: "Phone #", value: "phone", sortable: false },
        { text: "Email Address", value: "email", sortable: false },
        { text: "Address", value: "address", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      people: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        contact_id: 0,
        username: "",
        person: "",
        phone: "",
        email: "",
        address: "",
      },
      defaultItem: {
        id: 0,
        contact_id: 0,
        username: "",
        person: "",
        phone: "",
        email: "",
        address: "",
      },
      selectedPeople: [],
      bookHeaders: [
        { text: "Event Date", align: "start", value: "date", sortable: false },
        { text: "Event", align: "start", value: "event", sortable: false },
        { text: "Person", value: "person", sortable: false },
      ],
      bookings: [],
      searchbook: "",
    };
  },
  created() {
    db.currentState.get(1, (result) => this.checkAssociation(result));
    var today = new Date();
    var todayTimeOffset = today.getTimezoneOffset() / -60;
    var todayLocalDate = new Date(today.getTime() + todayTimeOffset * 3600000);
    this.seldate = todayLocalDate.toISOString().substring(0, 10);
  },
  methods: {
    LookupUser() {
      // Look up a username
      this.lookup = true;
      this.error = "";
      const baseURL =
        "https://api.appery.io/rest/1/apiexpress/api/Bookings/Lookup_User/Lookup_User?apiKey=a0aa27a4-fc33-4916-af09-c21d30d69707&username=" +
        this.editedItem.username;
      axios
        .get(baseURL)
        .then((response) => {
          this.editedItem.contact_id = response.data[0].Contact_id;
          this.editedItem.person = response.data[0].Person;
          this.editedItem.phone = response.data[0].Phone;
          this.editedItem.email = response.data[0].Email;
          this.editedItem.address = response.data[0].Address;
          this.lookup = false;
        })
        .catch((error) => {
          this.editedItem.contact_id = 0;
          this.editedItem.username = "";
          this.editedItem.person = "";
          this.editedItem.phone = "";
          this.editedItem.email = "";
          this.editedItem.address = "";
          this.lookup = false;
          console.log(error);
          this.error = "Username not found on OwnUrGoal";
        });
    },
    SelectedEvent(event) {
      this.selEvent =
        event.title + " from " + event.start_time + " To " + event.end_time;
      this.selEventId = event.event_id;
      this.renderPeople = true;
      this.stepAction("+");
    },
    setAssoc() {
      db.currentState
        .update(1, { Association: this.selectedAssociation })
        .then(function(updated) {
          updated
            ? console.log("Association Information in currentState updated")
            : console.log(
                "Association Information in currentState not updated"
              );
        });
    },
    checkAssociation(curState) {
      db.associations.toArray((assoc) => this.loadAssoc(assoc, curState));
    },
    loadAssoc(result, curState) {
      if (result.length > 0) {
        this.associations = result;
        this.associationNames = [];
        const numAssociations = this.associations.length;
        for (let index = 0; index < numAssociations; index++) {
          const element = this.associations[index];
          if (element.code_id == curState.Association) {
            this.selAssociation = element.Detail;
          }
          this.associationNames.push(element.Detail);
        }
        this.associationNames.sort();
        this.LoadPeople();
      } else {
        this.LoadAssociations(curState);
      }
    },
    LoadAssociations(res) {
      this.loading = true;
      this.startPageLoad = true;
      // Load up the associations for Qld
      const baseURL =
        "https://api.appery.io/rest/1/apiexpress/api/Bookings/Get_Associations/Get_Associations?apiKey=a0aa27a4-fc33-4916-af09-c21d30d69707&organisation=" +
        this.organisation;
      axios
        .get(baseURL)
        .then((response) => {
          const numAssociations = response.data.length;
          for (let index = 0; index < numAssociations; index++) {
            const element = response.data[index];
            if (res && element.code_id == res.Association) {
              this.selAssociation = element.Detail;
            }
            this.saveDexie({
              ele: element,
              desc: "Associations",
            });
          }
          this.startPageLoad = false;
          this.loading = false;
          this.LoadPeople();
        })
        .catch((error) => {
          console.log(error);
          this.error =
            "Error loading Associations - please check details and try again";
        });
    },
    LoadEvents() {
      // reset events list
      this.events = [];
      // Load up the Events for selected Association and Date
      const baseURL =
        "https://api.appery.io/rest/1/apiexpress/api/Bookings/Get_Events/Get_Events?apiKey=a0aa27a4-fc33-4916-af09-c21d30d69707&Association=" +
        this.selectedAssociation +
        "&date=" +
        this.dateLookup;
      axios
        .get(baseURL)
        .then((response) => {
          const numEvents = response.data.length;
          for (let index = 0; index < numEvents; index++) {
            const element = response.data[index];
            this.saveDexie({
              ele: element,
              desc: "events",
            });
          }
          this.loading = false;
          this.step = 2;
          this.renderEvents = true;
        })
        .catch((error) => {
          console.log(error);
          this.error =
            "Error loading Events - please check details and try again";
        });
    },
    LoadPeople() {
      db.people.toArray((person) => this.loadPerson(person));
    },
    loadPerson(result) {
      this.people = result;
    },
    async saveDexie(params) {
      switch (params.desc) {
        case "Associations":
          await db.associations.put(params.ele);
          this.associations.push(params.ele);
          this.associationNames.push(params.ele.Detail);
          break;
        case "events":
          await db.events.put(params.ele);
          this.events.push(params.ele);
          break;
        default:
          break;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    LookupDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    stepAction(direction) {
      if (direction == "+") {
        switch (this.step) {
          case 1:
            // Load Events
            this.loading = true;
            this.LoadEvents();
            break;

          case 2:
            // Load People Page
            this.step++;
            break;

          case 3:
            // View Bookings
            this.step++;
            break;

          case 4:
            // final page ready to start again
            this.clearBookings();
            this.step = 1;
            break;
        }
      } else {
        this.step--;
      }
    },
    clearBookings() {
      db.bookings.clear();
      this.bookings = [];
      this.clearEvents();
    },
    clearEvents() {
      this.events = [];
      db.events.clear();
    },
    editItem(item) {
      this.editedIndex = this.people.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const id = item.id;
      confirm("Are you sure you want to delete " + item.person) &&
        db.people.delete(id);
      this.LoadPeople();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.Person.validate()) {
        if (this.editedIndex > -1) {
          //Object.assign(this.people[this.editedIndex], this.editedItem);
          db.people
            .update(this.editedItem.id, {
              contact_id: this.editedItem.contact_id,
              username: this.editedItem.username,
              person: this.editedItem.person,
              phone: this.editedItem.phone,
              email: this.editedItem.email,
              address: this.editedItem.address,
            })
            .then(function(updated) {
              updated
                ? console.log("Person Information updated")
                : console.log("Person Information in people not updated");
            });
        } else {
          db.people.add({
            contact_id: this.editedItem.contact_id,
            username: this.editedItem.username,
            person: this.editedItem.person,
            phone: this.editedItem.phone,
            email: this.editedItem.email,
            address: this.editedItem.address,
          });
        }
        this.LoadPeople();
        this.close();
      }
    },
    processBookings() {
      this.loading = true;
      this.bookings = [];
      const numBookings = this.selectedPeople.length;
      for (let i = 0; i < numBookings; i++) {
        const element = {
          event_id: this.selEventId,
          event: this.selEvent,
          date: this.formatDate(this.seldate),
          username: this.selectedPeople[i].username,
          contact_id: this.selectedPeople[i].contact_id,
          person: this.selectedPeople[i].person,
          phone: this.selectedPeople[i].phone,
          email: this.selectedPeople[i].email,
          address: this.selectedPeople[i].address,
        };
        this.bookings.push(element);
        this.addBookingOUG(element);
      }
      this.emailBookingConfirmation();
      this.loading = false;
      this.stepAction("+");
    },
    addBookingOUG(element) {
      const baseURL =
        "https://api.appery.io/rest/1/apiexpress/api/Bookings/Process_Bookings/Post_Bookings?apiKey=a0aa27a4-fc33-4916-af09-c21d30d69707";
      axios
        .put(baseURL, element)
        .then((response) => {
          this.addBookingDB(response.data[0].insert_id, element);
        })
        .catch((error) => {
          console.log(error);
          this.error = "Username not found on OwnUrGoal";
        });
    },
    addBookingDB(_id, element) {
      let record = {
        id: _id,
        event_id: element.event_id,
        event: element.event,
        date: element.date,
        contact_id: element.contact_id,
        username: element.username,
        person: element.person,
        phone: element.phone,
        email: element.email,
        address: element.address,
      };
      db.bookings.put(record);
    },
    emailBookingConfirmation() {
      const baseURL =
        "https://ownurgoal.net.au:4100/utils/sendBookingConfirmationEmail";
      axios
        .post(baseURL, this.bookings)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
          this.error = "Unable to send email through OwnUrGoal";
        });
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Add a new Person Details"
        : "Edit Person Details";
    },
    dateFormatted() {
      return this.formatDate(this.seldate);
    },
    dateLookup() {
      return this.LookupDate(this.seldate);
    },
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Select Association and Date";
        case 2:
          return "Select Event for " + this.dateFormatted;
        case 3:
          return "Select People Attending ";
        //+ this.selEvent;
        case 4:
          return "Bookings Confirmed - Email Sent!";
        default:
          return "Procees OUG Bookings";
      }
    },
    selectedAssociation() {
      return this.associations.find((assoc_id) => {
        return assoc_id.Detail === this.selAssociation;
      }).code_id;
    },
  },
};
</script>
